import React, { useState } from 'react';
import { useTranslation } from '../../../i18n/TranslationProvider';
import Button from "../../../components/Button";


import LeftViewImg from '../../../assets/Left.png';
import BackViewImg from '../../../assets/Back.png';
import FrontViewImg from '../../../assets/Front.png';
import RightViewImg from '../../../assets/Right.png';
import HeadViewIMG from '../../../assets/Face.png';

const HOTSPOT_MAPPING = {
    // Head Injury Locations
    head_back: {
        part: "headInjuryLocation",
        option: "Back of Head",
        labelKey: "bodyMap.backOfHead"
    },
    head_left: {
        part: "headInjuryLocation",
        option: "Left Side of Head",
        labelKey: "bodyMap.leftSideOfHead"
    },
    head_front: {
        part: "headInjuryLocation",
        option: "Front of Head",
        labelKey: "bodyMap.frontOfHead"
    },
    head_top: {
        part: "headInjuryLocation",
        option: "Top of Head",
        labelKey: "bodyMap.topOfHead"
    },
    head_right: {
        part: "headInjuryLocation",
        option: "Right Side of Head",
        labelKey: "bodyMap.rightSideOfHead"
    },
    neck: {
        part: "headInjuryLocation",
        option: "Neck",
        labelKey: "bodyMap.neck"
    },

    // Facial / Head Features
    eye_left: {
        part: "eyes",
        option: "Left",
        labelKey: "bodyMap.leftEye"
    },
    eye_right: {
        part: "eyes",
        option: "Right",
        labelKey: "bodyMap.rightEye"
    },
    nose: {
        part: "nose",
        option: true,
        labelKey: "bodyMap.nose"
    },
    jaw_left: {
        part: "jaw",
        option: "Left",
        labelKey: "bodyMap.leftJaw"
    },
    jaw_right: {
        part: "jaw",
        option: "Right",
        labelKey: "bodyMap.rightJaw"
    },
    cheekbone_left: {
        part: "cheekbones",
        option: "Left",
        labelKey: "bodyMap.leftCheekbone"
    },
    cheekbone_right: {
        part: "cheekbones",
        option: "Right",
        labelKey: "bodyMap.rightCheekbone"
    },
    chin: {
        part: "chin",
        option: true,
        labelKey: "bodyMap.chin"
    },
    throat: {
        part: "throat",
        option: true,
        labelKey: "bodyMap.throat"
    },

    // Arms
    upper_arm_left: {
        part: "upper_arm",
        option: "Left",
        labelKey: "bodyMap.leftUpperArm"
    },
    upper_arm_right: {
        part: "upper_arm",
        option: "Right",
        labelKey: "bodyMap.rightUpperArm"
    },
    elbow_left: {
        part: "elbow",
        option: "Left",
        labelKey: "bodyMap.leftElbow"
    },
    elbow_right: {
        part: "elbow",
        option: "Right",
        labelKey: "bodyMap.rightElbow"
    },
    forearm_left: {
        part: "forearm",
        option: "Left",
        labelKey: "bodyMap.leftForearm"
    },
    forearm_right: {
        part: "forearm",
        option: "Right",
        labelKey: "bodyMap.rightForearm"
    },
    wrist_left: {
        part: "wrist",
        option: "Left",
        labelKey: "bodyMap.leftWrist"
    }, 
    wrist_right: {
        part: "wrist",
        option: "Right",
        labelKey: "bodyMap.rightWrist"
    },
    hand_left: {
        part: "hand",
        option: "Left",
        labelKey: "bodyMap.leftHand"
    },
    hand_right: {
        part: "hand",
        option: "Right",
        labelKey: "bodyMap.rightHand"
    },
    fingers_left: {
        part: "fingers",
        option: "Left",
        labelKey: "bodyMap.leftFingers"
    },
    fingers_right: {
        part: "fingers",
        option: "Right",
        labelKey: "bodyMap.rightFingers"
    },

    // Torso Areas
    chest_left: {
        part: "chest",
        option: "Left",
        labelKey: "bodyMap.leftChest"
    },
    chest_center: {
        part: "chest",
        option: "Center",
        labelKey: "bodyMap.centerChest"
    },
    chest_right: {
        part: "chest",
        option: "Right",
        labelKey: "bodyMap.rightChest"
    },
    shoulder_front_left: {
        part: "shoulder",
        option: "Front Left",
        labelKey: "bodyMap.frontLeftShoulder"
    },
    shoulder_front_right: {
        part: "shoulder",
        option: "Front Right",
        labelKey: "bodyMap.frontRightShoulder"
    },
    shoulder_back_left: {
        part: "shoulder",
        option: "Back Left",
        labelKey: "bodyMap.backLeftShoulder"
    },
    shoulder_back_right: {
        part: "shoulder",
        option: "Back Right",
        labelKey: "bodyMap.backRightShoulder"
    },
    upper_back_left: {
        part: "upper_back",
        option: "Left",
        labelKey: "bodyMap.upperBackLeft"
    },
    upper_back_center: {
        part: "upper_back",
        option: "Center",
        labelKey: "bodyMap.upperBackCenter"
    },
    upper_back_right: {
        part: "upper_back",
        option: "Right",
        labelKey: "bodyMap.upperBackRight"
    },
    mid_back_left: {
        part: "mid_back",
        option: "Left",
        labelKey: "bodyMap.midBackLeft"
    },
    mid_back_center: {
        part: "mid_back",
        option: "Center",
        labelKey: "bodyMap.midBackCenter"
    },
    mid_back_right: {
        part: "mid_back",
        option: "Right",
        labelKey: "bodyMap.midBackRight"
    },
    lower_back_left: {
        part: "lower_back",
        option: "Left",
        labelKey: "bodyMap.lowerBackLeft"
    },
    lower_back_sacrum: {
        part: "lower_back",
        option: "Sacrum",
        labelKey: "bodyMap.lowerBackSacrum"
    },
    lower_back_right: {
        part: "lower_back",
        option: "Right",
        labelKey: "bodyMap.lowerBackRight"
    },

    // Lower Body
    hip_front_left: {
        part: "hip",
        option: "Front Left",
        labelKey: "bodyMap.frontLeftHip"
    },
    hip_front_right: {
        part: "hip",
        option: "Front Right",
        labelKey: "bodyMap.frontRightHip"
    },
    hip_back_left: {
        part: "hip",
        option: "Back Left",
        labelKey: "bodyMap.backLeftHip"
    },
    hip_back_right: {
        part: "hip",
        option: "Back Right",
        labelKey: "bodyMap.backRightHip"
    },
    knee_left: {
        part: "knee",
        option: "Left",
        labelKey: "bodyMap.leftKnee"
    },
    knee_right: {
        part: "knee",
        option: "Right",
        labelKey: "bodyMap.rightKnee"
    },
    femur_left: {
        part: "femur",
        option: "Left",
        labelKey: "bodyMap.leftFemur"
    },
    femur_right: {
        part: "femur",
        option: "Right",
        labelKey: "bodyMap.rightFemur"
    },
    shin_left: {
        part: "shin",
        option: "Left",
        labelKey: "bodyMap.leftShin"
    },
    shin_right: {
        part: "shin",
        option: "Right",
        labelKey: "bodyMap.rightShin"
    },
    calf_left: {
        part: "calf",
        option: "Left",
        labelKey: "bodyMap.leftCalf"
    },
    calf_right: {
        part: "calf",
        option: "Right",
        labelKey: "bodyMap.rightCalf"
    },
    ankle_left: {
        part: "ankle",
        option: "Left",
        labelKey: "bodyMap.leftAnkle"
    },
    ankle_right: {
        part: "ankle",
        option: "Right",
        labelKey: "bodyMap.rightAnkle"
    },
    foot_left: {
        part: "foot",
        option: "Left",
        labelKey: "bodyMap.leftFoot"
    },
    foot_right: {
        part: "foot",
        option: "Right",
        labelKey: "bodyMap.rightFoot"
    }
};

const InteractiveBodyMap = ({ impacts = {}, onToggleRegion }) => {
    const { t } = useTranslation();
    const [view, setView] = useState('front'); // 'front' | 'back'
    const [showAll, setShowAll] = useState(false);

    const isSelected = (spotKey) => {
        const spot = HOTSPOT_MAPPING[spotKey];
        if (!spot) return false;

        const { part, option } = spot;

        if (option === true) {
            return !!impacts?.[part];
        }

        return (
            Array.isArray(impacts?.[part]) &&
            impacts[part].includes(option)
        );
    };

    const getHotspotProps = (spotKey) => {
        const selected = isSelected(spotKey);

        let fill = "transparent";
        let stroke = "transparent";
        let strokeDasharray;

        if (selected) {
            fill = "rgba(16, 105, 149, 0.45)";
            stroke = "#106995";
        } else if (showAll) {
            fill = "rgba(16, 105, 149, 0.12)";
            stroke = "rgba(16, 105, 149, 0.6)";
            strokeDasharray = "3 2";
        }

        return {
            onClick: () => {
                const spot = HOTSPOT_MAPPING[spotKey];
                if (spot && onToggleRegion) {
                    onToggleRegion(spot.part, spot.option);
                }
            },
            children: <title>{HOTSPOT_MAPPING[spotKey] ? t(HOTSPOT_MAPPING[spotKey].labelKey) : ""}</title>,
            className: "cursor-pointer transition-all duration-200 hover:fill-primary/40",
            fill,
            stroke,
            strokeWidth: "1.5",
            strokeDasharray,
        };
    };

    // List of spot keys that belong to the head/face region
    const headHotspotKeys = [
        'head_top',
        'head_front',
        'head_back',
        'head_left',
        'head_right',
        'eye_left',
        'eye_right',
        'nose',
        'jaw_left',
        'jaw_right',
        'chin',
        'neck',
        'throat',
        'cheekbone_left',
        'cheekbone_right'
    ];

    const isHeadSelected = headHotspotKeys.some((key) => isSelected(key));

    const getSelectedLabels = () => {
        const labels = [];

        Object.values(HOTSPOT_MAPPING).forEach(
            ({ part, option, labelKey }) => {
                if (option === true && impacts?.[part]) {
                    const translatedLabel = t(labelKey);

                    if (!labels.includes(translatedLabel)) {
                        labels.push(translatedLabel);
                    }
                } else if (
                    Array.isArray(impacts?.[part]) &&
                    impacts[part].includes(option)
                ) {
                    const translatedLabel = t(labelKey);

                    if (!labels.includes(translatedLabel)) {
                        labels.push(translatedLabel);
                    }
                }
            }
        );

        return labels;
    };

    const selectedLabels = getSelectedLabels();

    return (
        <div className="bg-white p-6 border-b border-gray-200 mb-6">
            
           {/* Show available locations toggle */}
            <div className="flex justify-center mb-6">
                <button
                    type="button"
                    onClick={() => setShowAll((prev) => !prev)}
                    aria-pressed={showAll}
                    className={`px-4 py-1.5 text-xs font-semibold rounded-md border transition-all tracking-wider ${
                        showAll
                            ? ' text-primary border-primary bg-primary/10'
                            : 'bg-white text-gray-600 border-gray-200 hover:text-gray-900'
                    }`}
                >
                    {showAll
                        ? t('bodyMap.hideAvailableLocations')
                        : t('bodyMap.showAvailableLocations')}
                </button>
            </div>

            {/* Body Profile View */}
            <div className="flex justify-center items-center max-w-4xl mx-auto gap-4 mb-8">
                {view === 'front' ? (
                    /* Front View */
                    <div className="flex flex-col items-center">
                        <div className="relative w-[175px] h-[350px]">
                            <img
                                src={FrontViewImg}
                                alt={t("bodyMap.front")}
                                className="w-full h-full object-contain pointer-events-none select-none"
                            />

                            <svg
                                viewBox="0 0 140 280"
                                className="absolute inset-0 w-full h-full"
                            >
                                {/* Head & Neck */}
                                <ellipse
                                    cx="67"
                                    cy="12"
                                    rx="15"
                                    ry="8"
                                    {...getHotspotProps("head_top")}
                                />
                                <ellipse
                                    cx="67"
                                    cy="24"
                                    rx="15"
                                    ry="9"
                                    {...getHotspotProps("head_front")}
                                />
                                <rect
                                    x="61"
                                    y="40"
                                    width="14"
                                    height="12"
                                    rx="2"
                                    {...getHotspotProps("neck")}
                                />

                                {/* Shoulders & Arms (Anatomical Right = Viewer's Left) */}
                                <rect
                                    x="32"
                                    y="55"
                                    width="18"
                                    height="22"
                                    rx="5"
                                    {...getHotspotProps("shoulder_front_right")}
                                />
                                <rect
                                    x="86"
                                    y="55"
                                    width="18"
                                    height="22"
                                    rx="5"
                                    {...getHotspotProps("shoulder_front_left")}
                                />
                                <rect
                                    x="33"
                                    y="78"
                                    width="12"
                                    height="24"
                                    rx="3"
                                    {...getHotspotProps("upper_arm_right")}
                                />
                                <rect
                                    x="90"
                                    y="78"
                                    width="12"
                                    height="24"
                                    rx="3"
                                    {...getHotspotProps("upper_arm_left")}
                                />
                                <ellipse
                                    cx="37"
                                    cy="106"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("elbow_right")}
                                />
                                <ellipse
                                    cx="97"
                                    cy="106"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("elbow_left")}
                                />
                                <rect
                                    x="26"
                                    y="112"
                                    width="13"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("forearm_right")}
                                />
                                <rect
                                    x="96"
                                    y="112"
                                    width="13"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("forearm_left")}
                                />
                                <rect
                                    x="21"
                                    y="132"
                                    width="14"
                                    height="8"
                                    rx="2"
                                    {...getHotspotProps("wrist_right")}
                                />
                                <rect
                                    x="98"
                                    y="132"
                                    width="14"
                                    height="8"
                                    rx="2"
                                    {...getHotspotProps("wrist_left")}
                                />
                                <ellipse
                                    cx="25"
                                    cy="147"
                                    rx="7"
                                    ry="7"
                                    {...getHotspotProps("hand_right")}
                                />
                                <ellipse
                                    cx="109"
                                    cy="147"
                                    rx="7"
                                    ry="7"
                                    {...getHotspotProps("hand_left")}
                                />
                                <ellipse
                                    cx="23"
                                    cy="160"
                                    rx="6"
                                    ry="5"
                                    {...getHotspotProps("fingers_right")}
                                />
                                <ellipse
                                    cx="111"
                                    cy="160"
                                    rx="6"
                                    ry="5"
                                    {...getHotspotProps("fingers_left")}
                                />

                                {/* Chest & Torso */}
                                <rect
                                    x="44"
                                    y="82"
                                    width="15"
                                    height="28"
                                    rx="3"
                                    {...getHotspotProps("chest_right")}
                                />
                                <rect
                                    x="60"
                                    y="82"
                                    width="17"
                                    height="28"
                                    rx="3"
                                    {...getHotspotProps("chest_center")}
                                />
                                <rect
                                    x="78"
                                    y="82"
                                    width="15"
                                    height="28"
                                    rx="3"
                                    {...getHotspotProps("chest_left")}
                                />

                                {/* Hips & Lower Body */}
                                <rect
                                    x="38"
                                    y="140"
                                    width="25"
                                    height="30"
                                    rx="4"
                                    {...getHotspotProps("hip_front_right")}
                                />
                                <rect
                                    x="73"
                                    y="140"
                                    width="25"
                                    height="30"
                                    rx="4"
                                    {...getHotspotProps("hip_front_left")}
                                />
                                <rect
                                    x="47"
                                    y="170"
                                    width="17"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("femur_right")}
                                />
                                <rect
                                    x="72"
                                    y="170"
                                    width="17"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("femur_left")}
                                />
                                <ellipse
                                    cx="58"
                                    cy="200"
                                    rx="9"
                                    ry="12"
                                    {...getHotspotProps("knee_right")}
                                />
                                <ellipse
                                    cx="78"
                                    cy="200"
                                    rx="9"
                                    ry="12"
                                    {...getHotspotProps("knee_left")}
                                />
                                <rect
                                    x="51"
                                    y="212"
                                    width="13"
                                    height="32"
                                    rx="3"
                                    {...getHotspotProps("shin_right")}
                                />
                                <rect
                                    x="72"
                                    y="212"
                                    width="13"
                                    height="32"
                                    rx="3"
                                    {...getHotspotProps("shin_left")}
                                />
                                <ellipse
                                    cx="58"
                                    cy="254"
                                    rx="7"
                                    ry="6"
                                    {...getHotspotProps("ankle_right")}
                                />
                                <ellipse
                                    cx="77"
                                    cy="254"
                                    rx="7"
                                    ry="6"
                                    {...getHotspotProps("ankle_left")}
                                />
                                <ellipse
                                    cx="58"
                                    cy="267"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("foot_right")}
                                />
                                <ellipse
                                    cx="78"
                                    cy="267"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("foot_left")}
                                />
                            </svg>
                        </div>
                    </div>
                ) : (
                    /* Back View */
                    <div className="flex flex-col items-center">
                        <div className="relative w-[180px] h-[360px]">
                            <img
                                src={BackViewImg}
                                alt={t("bodyMap.back")}
                                className="w-full h-full object-contain pointer-events-none select-none"
                            />

                            <svg
                                viewBox="0 0 140 280"
                                className="absolute inset-0 w-full h-full"
                            >
                                {/* Head & Neck */}
                                <ellipse
                                    cx="70"
                                    cy="12"
                                    rx="15"
                                    ry="8"
                                    {...getHotspotProps("head_top")}
                                />
                                <ellipse
                                    cx="70"
                                    cy="28"
                                    rx="15"
                                    ry="12"
                                    {...getHotspotProps("head_back")}
                                />
                                <rect
                                    x="62"
                                    y="44"
                                    width="17"
                                    height="12"
                                    rx="2"
                                    {...getHotspotProps("neck")}
                                />

                                {/* Shoulders & Arms  */}
                                <rect
                                    x="35"
                                    y="54"
                                    width="20"
                                    height="22"
                                    rx="3"
                                    {...getHotspotProps("shoulder_back_left")}
                                />
                                <rect
                                    x="86"
                                    y="54"
                                    width="20"
                                    height="22"
                                    rx="3"
                                    {...getHotspotProps("shoulder_back_right")}
                                />
                                <rect
                                    x="32"
                                    y="78"
                                    width="14"
                                    height="24"
                                    rx="3"
                                    {...getHotspotProps("upper_arm_left")}
                                />
                                <rect
                                    x="92"
                                    y="78"
                                    width="14"
                                    height="24"
                                    rx="3"
                                    {...getHotspotProps("upper_arm_right")}
                                />
                                <ellipse
                                    cx="40"
                                    cy="106"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("elbow_left")}
                                />
                                <ellipse
                                    cx="98"
                                    cy="106"
                                    rx="8"
                                    ry="6"
                                    {...getHotspotProps("elbow_right")}
                                />
                                <rect
                                    x="30"
                                    y="112"
                                    width="13"
                                    height="22"
                                    rx="3"
                                    {...getHotspotProps("forearm_left")}
                                />
                                <rect
                                    x="97"
                                    y="112"
                                    width="13"
                                    height="22"
                                    rx="3"
                                    {...getHotspotProps("forearm_right")}
                                />
                                <rect
                                    x="24"
                                    y="134"
                                    width="14"
                                    height="6"
                                    rx="2"
                                    {...getHotspotProps("wrist_left")}
                                />
                                <rect
                                    x="100"
                                    y="134"
                                    width="14"
                                    height="6"
                                    rx="2"
                                    {...getHotspotProps("wrist_right")}
                                />
                                <ellipse
                                    cx="30"
                                    cy="145"
                                    rx="7"
                                    ry="7"
                                    {...getHotspotProps("hand_left")}
                                />
                                <ellipse
                                    cx="111"
                                    cy="145"
                                    rx="7"
                                    ry="7"
                                    {...getHotspotProps("hand_right")}
                                />
                                <ellipse
                                    cx="28"
                                    cy="158"
                                    rx="6"
                                    ry="5"
                                    {...getHotspotProps("fingers_left")}
                                />
                                <ellipse
                                    cx="111"
                                    cy="158"
                                    rx="6"
                                    ry="5"
                                    {...getHotspotProps("fingers_right")}
                                />

                                {/* Back Torso */}
                                <rect
                                    x="45"
                                    y="76"
                                    width="15"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("upper_back_left")}
                                />
                                <rect
                                    x="61"
                                    y="76"
                                    width="18"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("upper_back_center")}
                                />
                                <rect
                                    x="80"
                                    y="76"
                                    width="15"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("upper_back_right")}
                                />
                                <rect
                                    x="47"
                                    y="98"
                                    width="12"
                                    height="18"
                                    rx="3"
                                    {...getHotspotProps("mid_back_left")}
                                />
                                <rect
                                    x="60"
                                    y="98"
                                    width="20"
                                    height="18"
                                    rx="3"
                                    {...getHotspotProps("mid_back_center")}
                                />
                                <rect
                                    x="80"
                                    y="98"
                                    width="12"
                                    height="18"
                                    rx="3"
                                    {...getHotspotProps("mid_back_right")}
                                />
                                <rect
                                    x="45"
                                    y="118"
                                    width="14"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("lower_back_left")}
                                />
                                <rect
                                    x="61"
                                    y="118"
                                    width="18"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("lower_back_sacrum")}
                                />
                                <rect
                                    x="81"
                                    y="118"
                                    width="14"
                                    height="20"
                                    rx="3"
                                    {...getHotspotProps("lower_back_right")}
                                />

                                {/* Hips & Lower Body */}
                                <rect
                                    x="40"
                                    y="140"
                                    width="22"
                                    height="28"
                                    rx="4"
                                    {...getHotspotProps("hip_back_left")}
                                />
                                <rect
                                    x="78"
                                    y="140"
                                    width="22"
                                    height="28"
                                    rx="4"
                                    {...getHotspotProps("hip_back_right")}
                                />
                                <rect
                                    x="48"
                                    y="168"
                                    width="15"
                                    height="26"
                                    rx="3"
                                    {...getHotspotProps("femur_left")}
                                />
                                <rect
                                    x="76"
                                    y="168"
                                    width="15"
                                    height="26"
                                    rx="3"
                                    {...getHotspotProps("femur_right")}
                                />
                                <ellipse
                                    cx="54"
                                    cy="205"
                                    rx="9"
                                    ry="12"
                                    {...getHotspotProps("knee_left")}
                                />
                                <ellipse
                                    cx="86"
                                    cy="205"
                                    rx="9"
                                    ry="12"
                                    {...getHotspotProps("knee_right")}
                                />
                                <rect
                                    x="47"
                                    y="218"
                                    width="14"
                                    height="30"
                                    rx="3"
                                    {...getHotspotProps("calf_left")}
                                />
                                <rect
                                    x="79"
                                    y="218"
                                    width="14"
                                    height="30"
                                    rx="3"
                                    {...getHotspotProps("calf_right")}
                                />
                                <ellipse
                                    cx="55"
                                    cy="255"
                                    rx="7"
                                    ry="6"
                                    {...getHotspotProps("ankle_left")}
                                />
                                <ellipse
                                    cx="86"
                                    cy="255"
                                    rx="7"
                                    ry="6"
                                    {...getHotspotProps("ankle_right")}
                                />
                                <ellipse
                                    cx="53"
                                    cy="265"
                                    rx="9"
                                    ry="6"
                                    {...getHotspotProps("foot_left")}
                                />
                                <ellipse
                                    cx="88"
                                    cy="265"
                                    rx="9"
                                    ry="6"
                                    {...getHotspotProps("foot_right")}
                                />
                            </svg>
                        </div>
                    </div>
                )}
            </div>

             {/* View Toggle Buttons (left/right) */}
            <div className="flex justify-center mb-6">
                <div className="inline-flex rounded-md bg-gray-100 p-1">
                    <button
                        type="button"
                        onClick={() => setView('front')}
                        className={`px-4 py-1.5 text-xs font-semibold rounded-md transition-all uppercase tracking-wider ${
                            view === 'front'
                                ? 'bg-white text-primary shadow-sm'
                                : 'text-gray-600 hover:text-gray-900'
                        }`}
                    >
                        {t('bodyMap.front')}
                    </button>
                    <button
                        type="button"
                        onClick={() => setView('back')}
                        className={`px-4 py-1.5 text-xs font-semibold rounded-md transition-all uppercase tracking-wider ${
                            view === 'back'
                                ? 'bg-white text-primary shadow-sm'
                                : 'text-gray-600 hover:text-gray-900'
                        }`}
                    >
                        {t('bodyMap.back')}
                    </button>
                </div>
            </div>

            <hr className="border-gray-100 my-6" />

            {/* Head Injury Selection */}
            {isHeadSelected && (
                <div className="mb-6">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3 text-center">
                        Face & Head injury selection
                    </p>

                    <div className="relative w-[140px] h-[160px] mx-auto">
                        <img
                            src={HeadViewIMG}
                            alt="Close up of head"
                            className="w-full h-full object-contain pointer-events-none select-none"
                        />

                        <svg
                            viewBox="0 0 240 280"
                            className="absolute inset-0 w-full h-full"
                        >
                            {/* Head regions */}
                            <ellipse
                                cx="120"
                                cy="28"
                                rx="48"
                                ry="20"
                                {...getHotspotProps("head_top")}
                            />
                            <ellipse
                                cx="120"
                                cy="66"
                                rx="44"
                                ry="20"
                                {...getHotspotProps("head_front")}
                            />
                            <ellipse
                                cx="65"
                                cy="80"
                                rx="18"
                                ry="36"
                                {...getHotspotProps("head_right")}
                            />
                            <ellipse
                                cx="175"
                                cy="80"
                                rx="18"
                                ry="36"
                                {...getHotspotProps("head_left")}
                            />

                            {/* Face features */}
                            <ellipse
                                cx="94"
                                cy="117"
                                rx="20"
                                ry="15"
                                {...getHotspotProps("eye_right")}
                            />
                            <ellipse
                                cx="146"
                                cy="117"
                                rx="20"
                                ry="15"
                                {...getHotspotProps("eye_left")}
                            />
                            <polygon
                                points="120,116 106,160 134,160"
                                {...getHotspotProps("nose")}
                            />
                            <rect
                                x="62"
                                y="170"
                                width="26"
                                height="45"
                                rx="4"
                                {...getHotspotProps("jaw_right")}
                            />
                            <rect
                                x="152"
                                y="170"
                                width="26"
                                height="45"
                                rx="4"
                                {...getHotspotProps("jaw_left")}
                            />
                            <ellipse
                                cx="78"
                                cy="152"
                                rx="25"
                                ry="14"
                                {...getHotspotProps("cheekbone_right")}
                            />
                            <ellipse
                                cx="162"
                                cy="152"
                                rx="25"
                                ry="14"
                                {...getHotspotProps("cheekbone_left")}
                            />
                            <ellipse
                                cx="120"
                                cy="220"
                                rx="25"
                                ry="12"
                                {...getHotspotProps("chin")}
                            />

                            {/* Neck/throat */}
                            <rect
                                x="100"
                                y="230"
                                width="40"
                                height="50"
                                rx="4"
                                {...getHotspotProps("throat")}
                            />
                        </svg>
                    </div>
                </div>
            )}

            {/* Selected Regions Box */}
            <p className="text-sm font-semibold text-gray-700 mb-1">
                {t("bodyMap.selectedRegions")}
            </p>

            {selectedLabels.length === 0 ? (
                <p className="text-sm italic text-gray-400">
                    {t("bodyMap.noRegionsSelected")}
                </p>
            ) : (
                <div className="flex flex-wrap gap-2 mt-2">
                    {selectedLabels.map((lbl) => (
                        <span
                            key={lbl}
                            className="bg-gray-50 text-gray-700 text-xs px-2.5 py-1 rounded-full border border-gray-200 font-medium"
                        >
                            {lbl}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default InteractiveBodyMap;